// import {createRouter, createWebHistory, createWebHashHistory} from 'vue-router'

import IndexRoutes from "@/router/IndexRoutes";
import ChatGPTRoutes from "@/router/ChatGPTRoutes";
import NetFlixRoutes from "@/router/NetFlixRoutes";
import AppleIdRoutes from "@/router/AppleIdRoutes";
import DuolingoRoutes from "@/router/DuolingoRoutes";
import AdminRoutes from "@/router/AdminRoutes";
import CrunchyrollRoutes from "@/router/CrunchyrollRoutes";
import UserRoutes from "@/router/User";
import AiToolRoutes from "@/router/AiToolRoutes";

let VueRouter;

// console.log("当前环境变量 VUE_APP_ENV:", process.env.VUE_APP_ENV);  // 输出环境变量值，帮助调试

if (process.env.VUE_APP_ENV === 'development') {
    console.log("获取本地 vue-router");
    VueRouter = require('vue-router');
    globalThis.VueRouter = VueRouter;  // 将 Vuex 设为全局变量，供其他模块使用
} else {
    // console.log("获取 cdn vue-router");
    VueRouter = window.VueRouter;  // 从全局对象中获取 Vuex，CDN 已加载到页面中
}

const { createRouter, createWebHistory } = VueRouter;
// console.log("初始化router")
const routes = [
    // 多语言首页  start
    ...IndexRoutes,
    // chatgpt 三合一多语言 start
    ...ChatGPTRoutes,
    // chatgpt 三合一语言 end
    // Netflix 三合一语言 start
    ...NetFlixRoutes,
    // Netflix 三合一语言 end
    // apple id 获取页面
    ...AppleIdRoutes,
    // Duolingo三合一页面
    ...DuolingoRoutes,
    // 管理后台
    ...AdminRoutes,
    // crunchyroll三合一路径
    ...CrunchyrollRoutes,
    // 用户邀请积分路劲
    ...UserRoutes,
    // ai工具路径
    ...AiToolRoutes,
    {
        path: '/:lang/products/:productType',
        name: 'ProductDetail',
        component: () => import('@/views/ProductDetail.vue')
    },
    {
        path: '/products/:productType',
        redirect: to => {
            return `/en${to.fullPath}`
        }
    }
]
//
const router = createRouter({
    history: createWebHistory(),
    // history: createWebHashHistory(),
    routes
})
// console.log("router初始化完成")
export default router
